import angular from 'angular';

export default angular.module('components.kbAdmin', [])
    .component('kbAdmin', {
        template: require('./kbAdmin.pug')(),
        controller: ['$state', 'CatalogService', function($state, CatalogService) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.load();
            };

            ctrl.load = function() {
                CatalogService.get({}).$promise.then(function(response) {
                    ctrl.content = response;
                });
            };
        }]
    })
    .component('kbAdminCatalog', {
        bindings: {
            id: '<'
        },
        template: require('./kbAdminCatalog.pug')(),
        controller: ['$state', 'CatalogService', 'DatabaseService', function($state, CatalogService, DatabaseService) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.load();
            };

            ctrl.load = function() {
                CatalogService.get({id: ctrl.id}).$promise.then(function(response) {
                    ctrl.catalog_content = response;
                });
                DatabaseService.get({repository: ctrl.id}).$promise.then(function(response) {
                    ctrl.content = response;
                });
            };
        }]
    })
    .component('kbAdminDatabase', {
        bindings: {
            id: '<',
            id2: '<'
        },
        template: require('./kbAdminDatabase.pug')(),
        controller: ['$state', '$interval', 'CatalogService','DatabaseService','StorageService', function($state, $interval, CatalogService, DatabaseService, StorageService) {
            var ctrl = this;
            var periodic;
            //const periodic_interval = 50000;

            ctrl.load = load;

            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.load();
            };


            //periodic = $interval(function() {
            //    StorageService.get({database: ctrl.id2}).$promise.then(function(response) {
            //        ctrl.content = response;
            //    });
            //}, periodic_interval);

            //ctrl.$onDestroy = function() {
            //    console.log('Desctroy periodic')
            //    $interval.cancel(periodic);
            //}

            function load() {
                CatalogService.get({id: ctrl.id}).$promise.then(function(response) {
                    ctrl.catalog_content = response;
                });
                DatabaseService.get({id: ctrl.id2}).$promise.then(function(response) {
                    ctrl.database_content = response;
                });
                StorageService.get({database: ctrl.id2}).$promise.then(function(response) {
                    ctrl.content = response;
                });
            };

        }]
    })
    /*
    .component('kbBrowser', {
        template: require('./kbBrowser.pug')(),
        controller: function() {
            var ctrl = this;

            ctrl.selectedCatalog = function(item) {
                if (ctrl.catalog != item.uuid)
                {
                    ctrl.catalog = item.uuid;
                    ctrl.database = undefined;
                    ctrl.file = undefined;
                }
            };

            ctrl.selectedDatabase = function(item) {
                if (ctrl.database != item.uuid)
                {
                    ctrl.database = item.uuid;
                    ctrl.file = undefined;
                }
            };

            ctrl.selectedFile = function(item) {
                ctrl.file = item.uuid
            };
        }
    })
    .component('kbCatalogList', {
        bindings: {
            selected: '<',
            onSelect: '&'
        },
        template: require('./kbCatalogList.pug')(),
        controller: ['CatalogService', function(CatalogService) {
            var ctrl = this;

            ctrl.$onInit = function() {
                load();
            };

            ctrl.load = load;

            ctrl.selectedItem = function(item) {
                ctrl.onSelect({item: item});
            };

            ////////

            function load() {
                var q = {};

                CatalogService.get(q).$promise.then(function(response) {
                    ctrl.response = response;
                }, function(err) {
                    console.log(err.message || err);
                });
            }

        }]
    })
    .component('kbCatalogListItem', {
        bindings: {
            item: '<',
            active: '<',
            onSelect: '&'
        },
        template: require('./kbCatalogListItem.pug')(),
        controller: function() {
            var ctrl = this;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.item) {
                        ctrl.item = changes.item.currentValue;
                    }
                }
            };
            
            ctrl.select = function() {
                ctrl.onSelect({item: ctrl.item});
            };
        }
    })
    .component('kbDatabaseList', {
        bindings: {
            selected: '<',
            catalog: '<',
            onSelect: '&'
        },
        template: require('./kbDatabaseList.pug')(),
        controller: ['DatabaseService', function(DatabaseService) {
            var ctrl = this;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.catalog) {
                        ctrl.catalog = changes.catalog.currentValue;
                        load();
                    }
                }
            }

            ctrl.load = load;

            ctrl.selectedItem = function(item) {
                ctrl.onSelect({item: item});
            };

            ////////

            function load() {

                var q = {
                    repository: ctrl.catalog
                };

                if (q.repository) {
                    DatabaseService.get(q).$promise.then(function(response) {
                        ctrl.response = response;
                    }, function(err) {
                        console.log(err.message || err);
                    });
                }
            }

        }]
    })
    .component('kbDatabaseListItem', {
        bindings: {
            item: '<',
            active: '<',
            onSelect: '&'
        },
        template: require('./kbDatabaseListItem.pug')(),
        controller: function() {
            var ctrl = this;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.item) {
                        ctrl.item = changes.item.currentValue;
                    }
                }
            };
            
            ctrl.select = function() {
                ctrl.onSelect({item: ctrl.item});
            };
        }
    })
    .component('kbFileList', {
        bindings: {
            selected: '<',
            database: '<',
            onSelect: '&'
        },
        template: require('./kbFileList.pug')(),
        controller: ['StorageService', function(StorageService) {
            var ctrl = this;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.database) {
                        ctrl.database = changes.database.currentValue;
                        load();
                    }
                }
            }

            ctrl.load = load;

            ctrl.selectedItem = function(item) {
                ctrl.onSelect({item: item});
            };

            ////////

            function load() {

                var q = {
                    database: ctrl.database
                };

                console.log('load', q);

                if (q.database) {
                    StorageService.get(q).$promise.then(function(response) {
                        ctrl.response = response;
                    }, function(err) {
                        console.log(err.message || err);
                    });
                }
            }
        }]
    })
    .component('kbFileListItem', {
        bindings: {
            item: '<',
            active: '<',
            onSelect: '&'
        },
        template: require('./kbFileListItem.pug')(),
        controller: function() {
            var ctrl = this;

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    if (changes.item) {
                        ctrl.item = changes.item.currentValue;
                    }
                }
            };
            
            ctrl.select = function() {
                ctrl.onSelect({item: ctrl.item});
            };
        }
    })
    */
    .value('KBAdminConfig', {
    })
    .name;
